import Vue from 'vue'
import VueI18n from 'vue-i18n'
// 引入elementui 的中英文翻译
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(VueI18n)

const DEFAULT_LANG = navigator.language || navigator.userLanguage

const locales = {
  zh: Object.assign(window.langZh, zhLocale), // 合并文件用来处理ui组件的中英文
  en: Object.assign(window.langEn, enLocale)
}

const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
  silentTranslationWarn: true
})

window.i18n = i18n
export default i18n
